<template>
  <!-- health documents modal -->
  <div id="healtgdocumentmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true"
    class="modal fade quick-ehr">
    <div role="document" class="modal-dialog wider-1">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" style="margin: 0 auto">Health Documents</h5>
          <button type="button" data-dismiss="modal" v-on:click="closeHealthDocument()" aria-label="Close" class="close"
            style="top: -17px">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body p-3">
          <div v-if="showspinner">
            <div class="processing_popup full-spinner" style="visibility: visible">
              <div class="spinner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
              </div>
            </div>
          </div>
          <div class="row no-gutter-mr">
            <div class="col-md-12">
              <div class="health-documents">
                <div class="file-upload">
                  <input class="input-padding" type="file" ref="fileInput" accept=".png, .jpg, .jpeg, .pdf" @change="handleFiles" />
                  <button class="primary-btn pull-right ripple" :class="{ 'global-disabled': !selectedFiles.length }"
                    @click="uploadFilesBase64" :disabled="!selectedFiles.length">Upload</button>
                  <a href="javascript:void(0);"
                    style="background: #0056e0; border: 0; color: #fff; font-size: 16px; padding: 9px 20px 8px; margin-left: 10px;"
                    @click="fetchDocuments()"><i class="fa fa-refresh"></i></a>
                </div>
                <div class="info-upload-i">
                  <span class="d-block mb-2">png, jpeg, pdf and <span> less than
                      4 MB</span></span>
                </div>
                <p v-if="fileWarning" style="color:red; margin-top:5px">{{ fileWarning }}</p>
                <div class="upload-document">
                  <h3>Uploaded Documents</h3>
                  <table class="table responsive mt-3 dashboard- staff-table">
                    <thead>
                      <tr>
                        <th>S. No.</th>
                        <th>File Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- No documents -->
                      <tr v-if="!documents || documents.length === 0">
                        <td colspan="3" class="text-center">
                          No documents available
                        </td>
                      </tr>

                      <!-- Documents list (paginated) -->
                      <tr v-else v-for="(doc, index) in paginatedDocuments" :key="doc.s3Key">
                        <td>{{ (currentPage - 1) * documentsPerPage + index + 1 }}</td>
                        <td>{{ doc.fileName.substring(doc.fileName.indexOf('_') + 1) }}</td>
                        <td>
                          <a href="javascript:void(0);" @click="openFile(doc.s3Key)">
                            <i class="fa fa-eye"></i>
                          </a>
                          <a href="javascript:void(0);" @click="deleteFile(doc.unique_id)">
                            <i class="fa fa-trash"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- Pagination -->
                  <div class="col-md-12 pull-left text-center" v-if="paginatedDocuments && paginatedDocuments.length > 0">
                    <ul class="main-pagination mt-3 mb-3">
                      <li v-if="currentPage > 1">
                        <a href @click.prevent="showPage(currentPage - 2)" class="pagination-previous">
                          <i class="material-icons">keyboard_arrow_left</i> Previous
                        </a>
                      </li>
                      <li class="mr-1" v-if="currentPage > 0" v-for="(n, index) in totalPages" :key="index"
                        @click.prevent="showPage(index)">
                        <a href :class="{ 'pagination-active': index + 1 == currentPage }">
                          {{ index + 1 }}
                        </a>
                      </li>
                      <li v-if="currentPage < totalPages">
                        <a href @click.prevent="showPage(currentPage)" class="pagination-next">
                          Next <i class="material-icons">keyboard_arrow_right</i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import rest_service from "@/api/rest_service";
import {  mapGetters } from "vuex";


export default {
  name: "UploadHealthDocument",

  props: {
    isAbhaEnabled: {
      type: Boolean,
      default: false,
    },
    isLinkWithAbhaSelected: {
      type: Boolean,
      default: false,
    },
    loggedinUserUniqueId: {
      type: String,
      default: "",
    },
    roleUniqueId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      customerId: "",
      patientDetails: null,
      selectedFiles: [],
      documents: [],
      fileWarning: "",
      warningTimer: null,
      showspinner: false,
      currentPage: 1,
      documentsPerPage: this.$store.state.helper.rowsPerPageInList,
    };
  },

  computed: {
    ...mapGetters([
      "gett_pdfurl",
      "gett_allowedFileSize"
    ]),

    totalPages() {
      return Math.ceil((this.documents || []).length / this.documentsPerPage);
    },

    paginatedDocuments() {
      const start = (this.currentPage - 1) * this.documentsPerPage;
      const end = start + this.documentsPerPage;
      return (this.documents || []).slice(start, end);
    },
  },

  methods: {
    open(customerId, patientDetails) {
      this.customerId = customerId;
      this.patientDetails = patientDetails;
      this.fetchDocuments();
      $("#healtgdocumentmodal").modal("show");
    },

    closeHealthDocument() {
      this.documents = [];
      this.currentPage = 1;
      $("#healtgdocumentmodal").modal("hide");
      this.$emit("close");
    },

    showPage(n) {
      this.currentPage = n + 1;
    },

    getCommonHeadershealth() {
      return {
        Authorization: localStorage.accesstoken,
        loggedin_user_unique_id: this.loggedinUserUniqueId,
        role_unique_id: this.roleUniqueId,
        route_entity_name: "/healthdocuments",
        x_tenant_id: localStorage.tenantid,
      };
    },

    handleFiles(event) {
      const file = event.target.files[0];
      if (!file) {
        this.selectedFiles = [];
        return;
      }

      const ext = file.name.split(".").pop().toLowerCase();
      const allowedTypes = this.$store.state.helper.acceptedFileTypes;
      const maxSize = 4 * 1024 * 1024;

      const showWarning = (msg) => {
        this.fileWarning = msg;
        this.selectedFiles = [];
        this.$refs.fileInput.value = "";

        if (this.warningTimer) clearTimeout(this.warningTimer);
        this.warningTimer = setTimeout(() => {
          this.fileWarning = "";
        }, 10000);
      };

      if (!allowedTypes.includes(ext)) {
        showWarning("Invalid file type.");
        return;
      }

      if (file.size > maxSize) {
        showWarning("File size exceeds the allowed limit.");
        return;
      }

      const isDuplicate = this.documents.find((f) => f.fileName === file.name);

      if (isDuplicate) {
        showWarning("Duplicate file not allowed.");
        return;
      }

      this.fileWarning = "";
      this.selectedFiles = [file];
    },

    async openFile(key) {
      const url = await this.getPresignedUrl(key);
      window.open(url, "_blank");
    },

    async getPresignedUrl(key) {
      const response = await Axios.get(
        `${rest_service.baseURL}/healthdocuments/presigned-url`,
        {
          params: { key },
          headers: this.getCommonHeadershealth(),
        }
      );
      return response.data;
    },
    
    async uploadFilesBase64() {
      this.showspinner = true;
      try {
        for (const file of this.selectedFiles) {
          const base64File = await this.convertToBase64(file);

          const payload = {
            fileName: file.name,
            contentType: file.type,
            customerId: this.customerId,
            base64File: base64File.split(",")[1],
            is_link_with_abha_selected: this.isLinkWithAbhaSelected,
          };

          await Axios.post(
            `${rest_service.baseURL}/healthdocuments/uploadBase64`,
            payload,
            {
              headers: {
                ...this.getCommonHeadershealth(),
                "Content-Type": "application/json",
              },
            }
          );
        }

        this.selectedFiles = [];
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
        }

        await this.fetchDocuments();

        if (this.isAbhaEnabled === true && this.patientDetails && this.patientDetails.mobile && this.patientDetails.abhaNumber && this.patientDetails.abhaAddress) {
          rest_service.abdmHeathicaDeepLink(localStorage.tenantid, this.patientDetails.mobile);
        }
      } catch (error) {
        console.error("Upload failed:", error);
      }finally {
        this.showspinner = false;
      }
    },

    convertToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    async fetchDocuments() {
      this.showspinner = true;
      try {
        const response = await Axios.get(
          `${rest_service.baseURL}/healthdocuments/list/${this.customerId}`,
          {
            headers: this.getCommonHeadershealth(),
          }
        );

        if (response && response.data) {
          this.documents = response.data;
          this.currentPage = 1;
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
      } finally {
        this.showspinner = false;
      }
    },

    async deleteFile(key) {
      await Axios.delete(
        `${rest_service.baseURL}/healthdocuments/delete/${encodeURIComponent(key)}`,
        {
          headers: this.getCommonHeadershealth(),
        }
      );

      await this.fetchDocuments();
    },
  },
};
</script>

<style scoped>
.input-padding{
  padding: 7px;
}
.file-upload{
  display: flex;
}
.upload-document table tr td a:last-child {
    margin-left: 15px;
    color: #f12121;
}
.upload-document table tr td a {
    font-size: 20px;
    color: #0056e0;
}
</style>